import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="menu.browse-the-catalogue" defaultMessage="Browse The Catalogue" />
);
